import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({ selector: '[dropFile]' })
export class DropFileDirective {

  @Output() files: EventEmitter<any> = new EventEmitter();

  constructor() { }

  @HostListener("dragover", ["$event"]) public onDragOver(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  @HostListener("dragleave", ["$event"]) public onDragLeave(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  @HostListener('drop', ['$event']) public onDrop(evt: DragEvent) {
    evt.preventDefault();
    evt.stopPropagation();
      const files = evt.dataTransfer?.files || [];
      if (files.length > 0) {
        this.files.emit(files);
      }
  }

}
